export const tokenUnicodeCharMap = [
    { symbol: 'wbtc', character: '₿', UTF16: '0x20BF' },
    { symbol: 'eth', character: 'Ξ ', UTF16: '0x039E' },
    // { symbol: 'usdc', character: '$', UTF16: '0x0024' },
    // { symbol: 'dai', character: '$', UTF16: '0x0024' },
    // { symbol: 'usdt', character: '$', UTF16: '0x0024' },
];
